import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { PoolSupplierAutocompleteList } from '../autocomplete-list/supplier-autocomplete-list/pool-supplier-autocomplete-list';
import { Supplier } from '../../models/supplier';

export const LegacySupplierFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (supplier: Supplier | null) => {
        filter.delete(FilterParams.SupplierAccountId);
        if (supplier) {
            updateCache(`supplierAccount_${supplier.id}`, supplier?.name);
            filter.set(FilterParams.SupplierAccountId, supplier.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (contactId: unknown): string => {
        if (typeof contactId !== 'string') {
            return '';
        }

        return getFromCache(`supplierAccount_${contactId}`) as string;
    };

    registerFilterMap(FilterParams.SupplierAccountId, getDisplayValue);

    return (
        <PoolSupplierAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.supplierAccount" />}
            required={false}
            initialValue={getDisplayValue(filter.get(FilterParams.SupplierAccountId)) ?? ''}
            disablePreventOverflow={true}
        />
    );
};
